var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready && _vm.isLoggedSynthetic)?[_c('div',{staticClass:"py-4"},[_c('h1',{staticClass:"h2 text-regular"},[_vm._v(" "+_vm._s(_vm.$t('login.title'))+" ")])]),_c('div',{staticClass:"py-4"},[_c('form-login',{attrs:{"external":""},on:{"logged":_vm.onLogged}})],1)]:_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }